export default __webpack_public_path__ + "static/media/memo_doc_ppt.e19ee06d.svg";